import { useTypedSelector } from 'common/hooks/store';
import { useDispatch } from 'react-redux';
import { onHideToast } from './toast.slice';
import { ToastType } from './toast.types';

export const Toast = () => {
  const dispatch = useDispatch();
  const toastItems = useTypedSelector((state) => state.toast.toasts);

  const getCssClasses = (toastType: ToastType) => {
    switch (toastType) {
      case ToastType.Success:
        return [
          'border-success-400',
          'text-success-400',
          'ra-icons-generic-check'
        ];
      case ToastType.Error:
        return [
          'border-error-300',
          'text-error-300',
          'ra-icons-generic-warning'
        ];
      default:
        throw Error(
          `Unexpected ToastType: ${toastType} has not been implemented`
        );
    }
  };

  return (
    <>
      {toastItems.map((toast) => {
        const [borderColourClass, textColourClass, iconClass] = getCssClasses(
          toast.type
        );

        return (
          <div
            key={toast.id}
            className={`w-92 bg-white border ${borderColourClass} rounded shadow-md p-3 mb-4 animate-in-from-right transition-all`}
            role="alert"
          >
            <div className="flex items-start">
              <i className={`text-lg ${textColourClass} ${iconClass}`}></i>
              <div className="mx-3">
                <strong>{toast.title}</strong>
                <p className="text-sm">{toast.description}</p>
              </div>
              <button
                onClick={() => dispatch(onHideToast(toast.id))}
                className="ml-auto"
              >
                <i
                  className={`ra-icons-generic-close-1 text-xs ${textColourClass}`}
                ></i>
              </button>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default Toast;
